// extracted by mini-css-extract-plugin
module.exports = {"container":"common_container__BXtPs"};